/**
 *
 * @module purchaseActivationStatus
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PurchaseActivationStatus
 * @type {Object}
 *
 * @property {String} ACTIVE
 * @property {String} EXPIRED
 * @property {String} FAILED
 * @property {String} IGNORED
 * @property {String} UNKNOWN
 *
 */

/**
 *
 * @enum
 * @type {PurchaseActivationStatus}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    ACTIVE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    EXPIRED: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    FAILED: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    IGNORED: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    UNKNOWN: null
});




// WEBPACK FOOTER //
// ./src/services/purchase/purchaseActivationStatus.js